
import detail from './detail'
import list from './list'

const cloudMarket = {
  path: 'cloudMarket',
  component: resolve => require(['../../../../pages/modules/cloudMarket'], resolve),
  redirect: 'cloudMarket/list',
  children: [
    detail,
    list
  ],
  meta: {
    requireAuth: true
  }
}

export default cloudMarket
